export default function isServerValidationError(error) {
  const { response, data } = error;
  return response.status === 422 && data.errors;
}
